module.exports = __webpack_public_path__ + "static/media/Zoom-In.bcf9d21f.svg";